import * as React from 'react';
import { useMemo } from 'react';
import { useTreeReferencesContext } from '../../../../../../../tree/references';
import { ExpressionReferenceInput } from '../../../../../../expressions/references/input/ExpressionReferenceInput';
import { WidgetType } from '../../../../../Widget';
import { ButtonActionContainer } from '../style/ButtonActionContainer';

export interface IButtonActionListAddConfigProps {
  name: string;
}

export function ButtonActionListAddConfig(
  props: IButtonActionListAddConfigProps,
) {
  const { references, root } = useTreeReferencesContext();

  const componentName = useMemo(() => {
    return `${props.name}.listReference`;
  }, [props.name]);

  if (!root) return null;

  return (
    <ButtonActionContainer name="Aggiungi alla lista">
      <ExpressionReferenceInput
        width="100%"
        references={references}
        name={componentName}
        config={{
          filter: ref => ref.widgetType === WidgetType.Repeatable,
        }}
      />
    </ButtonActionContainer>
  );
}
